import * as React from 'react';
import { Input } from 'semantic-ui-react';
import ReactDatePicker from 'react-datepicker';
import { DropdownArrowIcon } from './Icons/DropdownArrowIcon';
import { buildMonthsOptions, formatDateRange } from './utils';
import { DatePickerHeader } from './DatePickerHeader';




var EmptyComponent = React.createElement(React.Fragment, null);
var DatePickerComponent = function (_a) {
    var disabled = _a.disabled, className = _a.className, startDate = _a.startDate, endDate = _a.endDate, onChange = _a.onChange, name = _a.name, maxDate = _a.maxDate, minDate = _a.minDate, locale = _a.locale, monthSelectionLabel = _a.monthSelectionLabel;
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = React.useState(startDate), currentStartDate = _c[0], setCurrentStartDate = _c[1];
    var _d = React.useState(endDate), currentEndDate = _d[0], setCurrentEndDate = _d[1];
    var datePickerRef = React.createRef();
    React.useEffect(function () {
        var dateRageChanged = startDate !== currentStartDate || endDate !== currentEndDate;
        if (!dateRageChanged ||
            currentStartDate === null ||
            currentEndDate === null) {
            return;
        }
        onChange({
            startDate: currentStartDate,
            endDate: currentEndDate,
        });
    }, [currentStartDate, currentEndDate, onChange]);
    React.useEffect(function () {
        if (datePickerRef.current === null) {
            return;
        }
        // note: set our own value in components reference
        datePickerRef.current.setOpen(isOpen);
    }, [isOpen]);
    var toggleVisibility = React.useCallback(function () {
        setIsOpen(function (prevIsOpen) { return !prevIsOpen; });
    }, []);
    var handleDatesChange = React.useCallback(function (dates) {
        var startDate = dates[0], endDate = dates[1];
        setCurrentStartDate(startDate);
        setCurrentEndDate(endDate);
    }, []);
    var dateRangeDisplay = formatDateRange({ startDate: startDate, endDate: endDate });
    var classNames = ['DatePicker', 'pluggy'];
    if (className) {
        classNames.push(className);
    }
    if (disabled) {
        classNames.push('disabled');
    }
    var combinedClassNames = classNames.join(' ');
    var handleCalendarClose = React.useCallback(function () {
        setIsOpen(false);
    }, []);
    var handleCalendarOpen = React.useCallback(function () { return setIsOpen(true); }, []);
    var handleCustomHeaderRender = React.useCallback(function (_a) {
        var changeMonth = _a.changeMonth, changeYear = _a.changeYear, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, nextMonthButtonDisabled = _a.nextMonthButtonDisabled, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, date = _a.date;
        return (React.createElement(DatePickerHeader, { changeMonth: changeMonth, changeYear: changeYear, decreaseMonth: decreaseMonth, increaseMonth: increaseMonth, nextMonthButtonDisabled: nextMonthButtonDisabled, prevMonthButtonDisabled: prevMonthButtonDisabled, date: date, monthOptions: buildMonthsOptions(minDate, maxDate, locale), monthSelectionLabel: monthSelectionLabel }));
    }, [minDate, maxDate, locale]);
    return (React.createElement("div", { className: combinedClassNames },
        React.createElement("button", { className: "trigger", 
            // onMouseDown used instead of onClick to prevent input from being focused when clicked
            // TODO: make this solution less hacky and more semantically correct.
            onMouseDown: toggleVisibility, disabled: disabled },
            React.createElement(Input, { type: "text", value: dateRangeDisplay, className: "pluggy trigger-input " + (isOpen ? 'open' : ''), icon: React.createElement(DropdownArrowIcon, { onClick: handleCalendarOpen }), disabled: disabled, onFocus: handleCalendarOpen })),
        React.createElement(ReactDatePicker, { name: name, ref: datePickerRef, startDate: currentStartDate, endDate: currentEndDate, onChange: handleDatesChange, disabled: disabled, selectsRange: true, dateFormat: "dd/MM/yyyy", onCalendarClose: handleCalendarClose, onCalendarOpen: handleCalendarOpen, maxDate: maxDate, minDate: minDate, 
            // empty fragment to prevent the datepicker from rendering default input component
            customInput: EmptyComponent, renderCustomHeader: handleCustomHeaderRender })));
};
export var DatePicker = React.memo(DatePickerComponent);
